import type { LucideIcon as LucideIconType } from 'lucide-react';
import {
  ArrowRight,
  ArrowUp,
  ArrowUpRight,
  Building2,
  Calendar,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  CalendarPlus,
  ChefHat,
  CircleCheck,
  Clock,
  Coffee,
  ConciergeBell,
  ExternalLink,
  FileText,
  Heart,
  Home,
  Link2,
  Mail,
  MapPin,
  MapPinned,
  Martini,
  MessageCircle,
  MessageSquare,
  MessagesSquare,
  Phone,
  PhoneCall,
  PhoneOutgoing,
  Send,
  Share2,
  Smartphone,
  Sparkles,
  Star,
  Store,
  Ticket,
  UserRound,
  Users,
  Utensils,
  UtensilsCrossed,
  Wine,
} from 'lucide-react';
import {
  CTA_LUCIDE_CHANNEL_DEFAULTS,
  SECTION_LUCIDE_DEFAULTS,
  isCtaLucideIconKey,
} from './ctaLucideCatalog';

const CTA_LUCIDE_BY_KEY: Record<string, LucideIconType> = {
  CalendarCheck,
  Calendar,
  CalendarClock,
  CalendarDays,
  CalendarPlus,
  Ticket,
  MessageCircle,
  MessageSquare,
  MessagesSquare,
  Phone,
  PhoneCall,
  PhoneOutgoing,
  Smartphone,
  Mail,
  Send,
  ExternalLink,
  Link2,
  ArrowRight,
  ArrowUp,
  ArrowUpRight,
  Share2,
  CircleCheck,
  Sparkles,
  FileText,
  Utensils,
  UtensilsCrossed,
  ConciergeBell,
  Wine,
  Coffee,
  Martini,
  ChefHat,
  MapPin,
  MapPinned,
  Store,
  Building2,
  Home,
  Clock,
  Users,
  UserRound,
  Heart,
  Star,
};

export function resolveCtaLucideByIconKey(
  iconKey: string | null | undefined,
): LucideIconType | null {
  if (!iconKey || !isCtaLucideIconKey(iconKey)) {
    return null;
  }
  return CTA_LUCIDE_BY_KEY[iconKey] ?? null;
}

export function resolveReservationChannelIcon(
  channel: 'third-party' | 'messenger' | 'call',
  iconKey: string | null | undefined,
): LucideIconType {
  return (
    resolveCtaLucideByIconKey(iconKey) ??
    CTA_LUCIDE_BY_KEY[CTA_LUCIDE_CHANNEL_DEFAULTS[channel]] ??
    CalendarCheck
  );
}

export type SectionLucideDefaultKind = keyof typeof SECTION_LUCIDE_DEFAULTS;

/** Section-header / fact-row icon — content key or catalog default. */
export function resolveSectionLucideIcon(
  iconKey: string | null | undefined,
  fallback: SectionLucideDefaultKind | string,
): LucideIconType {
  const fallbackKey =
    fallback in SECTION_LUCIDE_DEFAULTS
      ? SECTION_LUCIDE_DEFAULTS[fallback as SectionLucideDefaultKind]
      : fallback;
  return (
    resolveCtaLucideByIconKey(iconKey) ??
    resolveCtaLucideByIconKey(fallbackKey) ??
    MapPin
  );
}
